import React from 'react';
import { Button } from 'antd';
import { ReloadOutlined, PrinterOutlined, ShareAltOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { SaveSearchButton } from '@client/components/SavedSearch';

/**
 * ResultsHeader Component
 * Header section for results screen with action buttons
 * Matches Figma design: Title on left, action buttons on right
 *
 * @param {Function} props.onReset - Handler for reset button click (null to hide)
 * @param {Function} props.onPrint - Handler for print button click
 * @param {Function} props.onShare - Handler for share button click (null to hide)
 * @param {boolean} props.isSharedView - Whether this is a shared results view (read-only)
 * @param {string} props.title - Optional custom title
 */
const ResultsHeader = ({
  onReset,
  onPrint,
  onShare,
  isSharedView = false,
  title,
}) => {
  const { t } = useTranslation('riskCalculator');

  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4">
      <h2 className="text-xl sm:text-2xl lg:text-3xl normal-case font-medium m-0">
        {title || t('results_screen_title')}
      </h2>

      <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full sm:w-auto">
        {/* Only show reset button when handler is provided */}
        {onReset && (
          <Button
            icon={<ReloadOutlined />}
            onClick={onReset}
            className="w-full sm:w-auto h-10 sm:h-[50px] px-3 sm:px-6 text-sm sm:text-base"
          >
            {t('btn_reset')}
          </Button>
        )}

        {onPrint && (
          <Button
            icon={<PrinterOutlined />}
            onClick={onPrint}
            className="w-full sm:w-auto h-10 sm:h-[50px] px-3 sm:px-6 text-sm sm:text-base"
          >
            {t('btn_print')}
          </Button>
        )}

        {/* Only show share button when handler is provided */}
        {onShare && (
          <Button
            icon={<ShareAltOutlined />}
            onClick={onShare}
            type="primary"
            className="w-full sm:w-auto h-10 sm:h-[50px] px-3 sm:px-6 text-sm sm:text-base"
          >
            {t('btn_share')}
          </Button>
        )}

        <SaveSearchButton
          searchType="risk_calculator"
          getCurrentUrl={() => window.location.href}
          className="w-full sm:w-auto h-10 sm:h-[50px] px-3 sm:px-6 text-sm sm:text-base"
        />
      </div>
    </div>
  );
};

export default ResultsHeader;